<template>
    <v-form @submit.prevent="save">
        <v-card class="mb-5 pa-2">
            <card-header
                :title="
                    $t('emails-form.texts.title', {
                        'title-prefix': titlePrefix,
                    })
                "
            >
            </card-header>
            <v-card-text>
                <v-row>
                    <v-col cols="12" xs="12" sm="12" md="6">
                        <v-text-field
                            flat
                            v-model="model.title"
                            :label="$t('emails-form.labels.title')"
                            :counter="50"
                            :error-messages="titleErrors"
                            @input="$v.model.title.$touch()"
                            @blur="$v.model.title.$touch()"
                            autofocus
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" xs="12" sm="12" md="6">
                        <v-text-field
                            flat
                            v-model="model.payload.from"
                            :label="$t('emails-form.labels.from')"
                            :counter="80"
                            :error-messages="fromErrors"
                            @input="$v.model.payload.from.$touch()"
                            @blur="$v.model.payload.from.$touch()"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" xs="12" sm="12" md="6">
                        <v-text-field
                            flat
                            v-model="model.payload.host"
                            :label="$t('emails-form.labels.host')"
                            :counter="255"
                            :error-messages="hostErrors"
                            @input="$v.model.payload.host.$touch()"
                            @blur="$v.model.payload.host.$touch()"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" xs="12" sm="12" md="6">
                        <v-text-field
                            flat
                            v-model="model.payload.port"
                            :label="$t('emails-form.labels.door')"
                            :counter="5"
                            :error-messages="portErrors"
                            @input="$v.model.payload.port.$touch()"
                            @blur="$v.model.payload.port.$touch()"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" xs="12" sm="12" md="6">
                        <v-text-field
                            flat
                            v-model="model.payload.username"
                            :label="$t('emails-form.labels.user')"
                            :counter="80"
                            :error-messages="usernameErrors"
                            @input="$v.model.payload.username.$touch()"
                            @blur="$v.model.payload.username.$touch()"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" xs="12" sm="12" md="6">
                        <v-text-field
                            flat
                            v-model="model.payload.password"
                            type="password"
                            :label="$t('emails-form.labels.password')"
                            :counter="80"
                            :error-messages="passwordErrors"
                            @input="$v.model.payload.password.$touch()"
                            @blur="$v.model.payload.password.$touch()"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" xs="12" sm="12" md="6">
                        <v-text-field
                            flat
                            v-model="model.to"
                            :label="$t('emails-form.labels.test-recipient')"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" xs="12" sm="12" md="6">
                        <label class="subtitle-2">
                            <v-icon left>mdi-shield-lock</v-icon>Criptografia
                        </label>
                        <v-radio-group v-model="model.payload.encryption" row>
                            <v-card
                                outlined
                                class="mr-2 pa-5"
                                v-for="encryption in encryptions"
                                :key="encryption.value"
                            >
                                <v-radio
                                    :label="encryption.label"
                                    :value="encryption.value"
                                ></v-radio>
                            </v-card>
                        </v-radio-group>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" xs="12" sm="12" md="6">
                        <label class="subtitle-2">
                            <v-icon left>mdi-email-lock</v-icon>Situação
                        </label>
                        <v-card outlined class="px-5 mt-5">
                            <v-switch
                                color="success"
                                inset
                                v-model="model.active"
                                :label="
                                    model.active
                                        ? $t('form.status.active')
                                        : $t('form.status.disabled')
                                "
                            ></v-switch>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card-text>

            <form-actions :loadingSave="loading">
                <template #middle>
                    <v-btn
                        color="indigo"
                        class="white--text"
                        @click="test"
                        :loading="testLoading"
                        depressed
                    >
                        <v-icon left small>mdi-email-alert</v-icon>
                        {{ $t('emails-form.buttons.test-configuration') }}
                    </v-btn>
                </template>
            </form-actions>
            <confirm
                ref="confirm"
                :persistent="true"
                width="500px"
                confirmColor="green"
                confirmText="Ativar"
            ></confirm>
        </v-card>
    </v-form>
</template>

<script>
import BaseModel from '@/models/BaseModel'
import CardHeader from '@/components/utils/CardHeader'
import FormActions from '@/components/utils/FormActions'
import Confirm from '@/components/dialogs/Confirm'
import { validationMixin } from 'vuelidate'
import {
    required,
    maxLength,
    integer,
    maxValue,
} from 'vuelidate/lib/validators'

export default {
    props: {
        model: {
            type: Object,
            required: true,
            validator: model => {
                return model instanceof BaseModel
            },
        },
        titlePrefix: String,
        isEdit: {
            type: Boolean,
            default: () => {
                return false
            },
        },
    },

    components: {
        confirm: Confirm,
        'card-header': CardHeader,
        'form-actions': FormActions,
    },

    data: () => {
        return {
            loading: false,
            testLoading: false,
            encryptions: [
                {
                    label: 'nenhuma',
                    value: '',
                },
                {
                    label: 'tls',
                    value: 'tls',
                },
                {
                    label: 'ssl',
                    value: 'ssl',
                },
            ],
        }
    },

    mixins: [validationMixin],

    validations: {
        model: {
            title: { required, maxLength: maxLength(50) },
            payload: {
                host: { required, maxLength: maxLength(255) },
                port: { required, integer, maxValue: maxValue(64000) },
                from: { required, maxLength: maxLength(80) },
                username: { required, maxLength: maxLength(80) },
                password: { required, maxLength: maxLength(80) },
                encryption: { maxLength: maxLength(20) },
            },
        },
    },

    methods: {
        async save() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$bus.$emit(
                    'notify',
                    'error',
                    this.$t('emails-form.bus.save-error'),
                )

                this.loading = false
                return
            }

            if (this.model.active) {
                let confirm = await this.$refs.confirm.open(
                    this.$t('emails-form.messages.configuration-active'),
                    this.$t(
                        'emails-form.messages.configuration-active-confirmation',
                    ),
                )

                if (!confirm) return
            }

            this.loading = true

            let clone = this.model.clone()

            let res = null

            try {
                res = await clone.save().catch(() => {})
            } finally {
                this.loading = false
            }

            if (!res) return

            this.$bus.$emit(
                'notify',
                'success',
                this.$t('emails-form.bus.save-success', { email: clone.title }),
            )

            this.$emit('saved')
        },

        async test() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$bus.$emit(
                    'notify',
                    'error',
                    this.$t('emails-form.bus.test-error'),
                )

                this.loading = false
                return
            }
            let data = this.model.clone().data()

            delete data.TYPE

            this.testLoading = true

            let test = null

            try {
                test = await this.$http.post('emails/test', data).catch(err => {
                    this.$bus.$emit(
                        'notify',
                        'error',
                        err.response.data.message || err.message,
                        15000,
                    )
                    return
                })
            } finally {
                this.testLoading = false
            }

            if (!test) return

            this.$bus.$emit(
                'notify',
                'success',
                this.$t('emails-form.bus.test-success'),
            )
        },
    },

    computed: {
        titleErrors() {
            const errors = []

            if (!this.$v.model.title.$dirty) return errors

            !this.$v.model.title.maxLength &&
                errors.push(
                    this.$t('emails-form.messages.title-error-max-length'),
                )

            !this.$v.model.title.required &&
                errors.push(
                    this.$t('emails-form.messages.title-error-required'),
                )

            return errors
        },

        hostErrors() {
            const errors = []

            if (!this.$v.model.payload.host.$dirty) return errors

            !this.$v.model.payload.host.required &&
                errors.push(this.$t('emails-form.messages.host-error-required'))

            !this.$v.model.payload.host.maxLength &&
                errors.push(
                    this.$t('emails-form.messages.host-error-max-length'),
                )

            return errors
        },

        portErrors() {
            const errors = []

            if (!this.$v.model.payload.port.$dirty) return errors

            !this.$v.model.payload.port.required &&
                errors.push(this.$t('emails-form.messages.door-error-required'))

            !this.$v.model.payload.port.integer &&
                errors.push(this.$t('emails-form.messages.door-error-integer'))

            !this.$v.model.payload.port.maxValue &&
                errors.push(this.$t('emails-form.messages.door-error-maxValue'))

            return errors
        },

        usernameErrors() {
            const errors = []

            if (!this.$v.model.payload.username.$dirty) return errors

            !this.$v.model.payload.username.required &&
                errors.push(this.$t('emails-form.messages.user-error-required'))

            !this.$v.model.payload.username.maxLength &&
                errors.push(
                    this.$t('emails-form.messages.user-error-max-length'),
                )

            return errors
        },

        fromErrors() {
            const errors = []

            if (!this.$v.model.payload.from.$dirty) return errors

            !this.$v.model.payload.from.required &&
                errors.push(this.$t('emails-form.messages.from-error-required'))

            !this.$v.model.payload.from.maxLength &&
                errors.push(
                    this.$t('emails-form.messages.from-error-max-length'),
                )

            return errors
        },

        passwordErrors() {
            const errors = []

            if (!this.$v.model.payload.password.$dirty) return errors

            !this.$v.model.payload.password.required &&
                errors.push(
                    this.$t('emails-form.messages.password-error-required'),
                )

            !this.$v.model.payload.password.maxLength &&
                errors.push(
                    this.$t('emails-form.messages.password-error-max-length'),
                )

            return errors
        },

        encryptionErrors() {
            const errors = []

            if (!this.$v.model.payload.encryption.$dirty) return errors

            !this.$v.model.payload.encryption.maxLength &&
                errors.push(
                    this.$t(
                        'emails-form.messages.cryptography-error-max-length',
                    ),
                )

            return errors
        },
    },
}
</script>
